<template>
  <div class="mobile-container" ref="Content">
    <div class="title-container">
      <img src="@/assets/images/cloud_l.png" alt="" />
      <div class="title-text">云游泰康之家</div>
      <img src="@/assets/images/cloud_r.png" alt="" />
    </div>
    <div class="list-container" v-if="initialFlag">
      <div
        class="list-content"
        v-if="lists.length > 0"
        :class="{ empty: lists.length == 0 }"
      >
        <div
          class="list-item"
          v-for="(item, index) in lists"
          :key="index"
          @click="run_720_cloud(item.playAddress)"
          :class="{
            active: currentImageIndex === index && !isHovered,
            hovered: hoveredIndex === index,
          }"
        >
          <div class="image-container">
            <div
              class="aspect-ratio-wrapper"
              :class="{
                active: currentImageIndex === index && !isHovered,
                hovered: hoveredIndex === index,
                out: outIndex === index,
              }"
            >
              <img
                v-if="item.materialName"
                :src="item.thumbnailAddress"
                :class="{
                  active: currentImageIndex === index && !isHovered,
                  hovered: hoveredIndex === index,
                }"
                @mouseover="onMouseOver(index)"
                @mouseout="onMouseOut"
                alt=""
              />
            </div>
          </div>

          <div v-if="item.materialName" class="list-item-bottom">
            <div class="name">{{ item.materialName }}</div>
            <img class="location-img" src="@/assets/images/location.png" />
            <div class="address" v-if="item.cityName">{{ item.cityName }}</div>
          </div>
        </div>
      </div>
      <div class="list-content" v-else>
        <div class="list-item" v-for="item in [1, 2]">
          <div class="image-container">
            <div class="aspect-ratio-wrapper">
              <div class="image-empty">
                <img src="@/assets/images/empty.png" alt="" />
                <div class="image-empty-text">敬请期待</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showlayout: 0,
      organizationCode: "",
      professionCode: "",
      categoryCode: "",
      options: [
        // {
        //   value: 'zhinan',
        //   label: '指南',
        //   children: [
        //     {
        //       value: 'shejiyuanze',
        //       label: '设计原则'
        //     },
        //     {
        //       value: 'daohang',
        //       label: '导航'
        //     }
        //   ]
        // },
        // {
        //   value: 'zujian',
        //   label: '组件'
        // },
        // {
        //   value: 'ziyuan',
        //   label: '资源'
        // }
      ],
      loading: false,
      pageIndex: 1,
      totalPage: 0,
      lists: [],
      tab_label: [
        { label: "VR视频", type: "1" },
        { label: "VR图片", type: "2" },
        { label: "社区数字孪生", type: "3" },
        { label: "平面视频", type: "4" },
        { label: "GIF动图", type: "5" },
      ],
      activeName: "1",
      Fixed: false,
      channelId: "",
      currentImageIndex: -1,
      isHovered: false,
      hoveredIndex: -1,
      outIndex: -1,
      timer: null,
      hoverTimeout: null,
      initialFlag: false,
    };
  },
  mounted() {
    // this.$refs.cascader._data.dropDownVisible = true
    // console.log(this.$refs.cascader._data.dropDownVisible)
    this.channelId = this.$route.query.id;
    console.log("pc.vue channelId : ", this.channelId);
    this.downlist();
    setTimeout(() => {
      if (!this.initialFlag) {
        setTimeout(() => {
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.lists.length;
        }, 300);
        this.initialFlag = true;
      }
      this.startAnimation();
    }, 500);
    /*       document.getElementsByClassName(
            'el-pagination__jump'
          )[0].childNodes[0].nodeValue = '跳至'
          window.addEventListener('scroll', this.handleScroll) */
    //this.list()
  },
  beforeDestroy() {
    this.stopAnimation();
    clearTimeout(this.hoverTimeout);
  },
  watch: {
    currentImageIndex(val) {
      setTimeout(() => {
        this.outIndex = val;
      }, 1000);
    },
    hoveredIndex(val) {
      setTimeout(() => {
        this.outIndex = val;
      }, 1000);
    },
  },
  computed: {
    paddedList() {
      const list = [...this.lists];
      const remainder = list.length % 2;
      if (remainder !== 0) {
        const paddingCount = 2 - remainder;
        for (let i = 0; i < paddingCount; i++) {
          list.push({
            materialName: null,
            organizationName: null,
            cityName: null,
            playAddress: null,
            thumbnailAddress: null,
          }); // 补充空白项
        }
      }
      return list;
    },
  },
  methods: {
    startAnimation() {
      this.stopAnimation(); // 清除之前的计时器
      this.timer = setInterval(() => {
        if (!this.isHovered) {
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.lists.length;
        }
      }, 5000); // 图片周期时间
    },
    stopAnimation() {
      clearInterval(this.timer);
    },
    onMouseOver(index) {
      this.isHovered = true;
      this.hoveredIndex = index;
      this.stopAnimation();
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.currentImageIndex = (this.hoveredIndex + 1) % this.lists.length;
        this.hoveredIndex = -1;
        this.isHovered = false;
        this.startAnimation();
      }, 30000);
    },
    onMouseOut() {
      this.isHovered = false;
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
      if (this.hoveredIndex != -1) {
        this.currentImageIndex = (this.hoveredIndex + 1) % this.lists.length;
        this.hoveredIndex = -1;
      }
      this.isHovered = false;
      this.startAnimation();
    },
    moveshow() {
      this.showlayout = 1;
      // this.$refs.cascader.style.height = 60 + 'px'
      // console.log(this.$refs.cascader.style.height)
    },
    mouseout() {
      this.showlayout = 0;
    },

    run_720_cloud(url) {
      /* window.open(url) */
      if (!url) return;
      this.$router.push({
        path: "/container",
        query: {
          index: url,
        },
      });
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.list();
    },
    tk_tab(type) {
      this.activeName = type;
      this.pageIndex = 1;
      this.categoryCode = type;
      this.list();
      console.log(this.$refs.cascader._data.dropDownVisible);
    },
    list() {
      this.loading = true;
      this.list = [];
      /* const params = {
          pageNum: this.pageIndex,
          pageSize: 15,
          categoryCode: this.categoryCode || '1',
          professionCode: this.professionCode,
          organizationCode: this.organizationCode
        }

        this.$api.getAddrList(params).then(res => {
          if (res.data.code == 0) {
            this.lists = res.data.data.list
            this.totalPage = res.data.data.total
            this.loading = false
          } else {
            this.lists = []
            this.totalPage = 0
            this.$message.error(res.data.message)
            this.loading = false
          }
        }) */
    },
    downlist() {
      if (typeof this.$route.query.id != "undefined") {
        // 链接携带了channelId
        console.log("downlist====获取其他渠道数据");
        // 云游泰康之家单独接口
        //this.getDataByChannel()
        this.$api.getDataByChannelId(this.$route.query.id).then((res) => {
          console.log("getDataByChannelId", res);
          if (res.data.code == 0) {
            this.lists = res.data.data;
            //this.totalPage = res.data.data.total
            //this.loading = false
          } else {
            this.lists = [];
            //this.totalPage = 0
            this.$message.error(res.data.message);
            //this.loading = false
          }
        });
      } else {
        console.log("downlist====获取云游泰康之家数据");
        // 云游泰康之家单独接口
        this.$api.getVisitHomeList().then((res) => {
          console.log("getVisitHomeList", res);
          if (res.data.code == 0) {
            this.lists = res.data.data;
            //this.totalPage = res.data.data.total
            //this.loading = false
          } else {
            this.lists = [];
            //this.totalPage = 0
            this.$message.error(res.data.message);
            //this.loading = false
          }
        });
      }
    },
    handleScroll() {
      // 滚动的距离
      const scrolled =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 容器的高度
      var offsetTop = 100;
      // console.log('scrollTop=>', scrolled, '  offsetTop=>', offsetTop)
      //  滚动的距离如果大于元素到顶部的距离时，实现吸顶效果
      if (scrolled > offsetTop) {
        this.Fixed = true;
        console.log(this.Fixed);
      } else {
        this.Fixed = false;
        console.log(this.Fixed);
      }
    },
  },
};
</script>
<style scoped lang="less">
.mobile-container {
  width: 100%;
  min-height: 100vh;
  background: url(../../assets/images/page_bg.png);
  background-size: contain;
  .list-content {
    padding: 0 3.75%;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    grid-gap: 2%;
    margin-top: 24px;

    .list-item {
      margin-bottom: 32px;
      width: 49%;
      position: relative;
      // background-color: #fff;
      // border: 1px solid red;
      // border-radius: 6px;
      transition: transform 1s ease-in-out;
    }

    .list-item.active {
      transform: scale(1.03);
      // &::before {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background-color: rgba(0, 0, 0, 0.1); /* 半透明黑色 */
      //   pointer-events: none; /* 防止遮罩挡住鼠标事件 */
      //   border-radius: inherit;
      // }
    }

    .list-item.hovered {
      transform: scale(1.03);
      // &::before {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background-color: rgba(0, 0, 0, 0.1); /* 半透明黑色 */
      //   pointer-events: none; /* 防止遮罩挡住鼠标事件 */
      //   border-radius: inherit;
      // }
    }

    .box-shadow {
      -webkit-box-shadow: 0 0.25rem 1rem rgba(48, 55, 66, 0.15);
      box-shadow: 0 4px 16px rgba(48, 55, 66, 0.15);
    }
  }
}

.title-container {
  display: flex;
  padding-top: 25px;
  align-items: center;
  justify-content: center;

  > img {
    height: 22px;
  }

  .title-text {
    padding: 0 14px;
    font-family: "FZY3JW--GB1";
    font-weight: normal;
    color: #ff8815;
    line-height: 52px;
  }
}

.image-container {
}

.image-container .aspect-ratio-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 75.05%; /* 16:9 的比例换算 (9/16 * 100%) */
  border-radius: 9px;
  overflow: hidden;
  // transition: border-radius 0s ease-in-out 1s;
}

.image-container .aspect-ratio-wrapper.active {
  border-radius: 9px;
}

.image-container .aspect-ratio-wrapper.hovered {
  border-radius: 9px;
}

.image-container .aspect-ratio-wrapper.out {
  transition: border-radius 0s ease-in-out 1s;
}

.image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 1s ease-in-out;
}

.image-container img.active {
  transform: scale(1.5);
}

.image-container img.hovered {
  transform: scale(1.5);
}

.image-empty {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  img {
    position: absolute;
    top: 9.6%;
    left: 19.9%;
    right: 19.9%;
    width: 60%;
    height: 79.8%;
  }
  .image-empty-text {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 22.36%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 20px;
    text-align: center;
    color: #6e6762;
  }
}

.list-item-bottom {
  margin-top: 16px;
  display: flex;
  align-items: center;

  .name {
    flex: 1;
    font-family: FZY4JW--GB1;
    font-size: 22px;
    color: #271f19;
    line-height: 27px;
  }

  .location-img {
    margin-top: 1px;
    margin-right: 4px;
    width: 16px;
  }

  .address {
    font-family: FZY3JW--GB1;
    font-weight: normal;
    font-size: 20px;
    color: #828282;
    line-height: 23px;
  }
}
</style>
